const menuItems = document.querySelectorAll('.mega-menu-list > li');

menuItems.forEach(item => {
  // event.preventDefault();
  const details = item.querySelector('details');
  item.addEventListener('mouseenter', () => {
    document.querySelectorAll('.mega-menu-list details[open]').forEach(openDetails => {
      openDetails.removeAttribute('open');
    });
    details.setAttribute('open', true);
  });
  item.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
  });
});
